import { bbox, centroid, featureCollection } from "@turf/turf";
import { MapProps } from "react-map-gl/mapbox";
import { useMemo } from "react";
import { UseMapViewportParams } from "../../types";

export type InitialViewState = NonNullable<MapProps["initialViewState"]>;
export const fallbackCoordinatesUK = [-0.1323, 50.8238] as const;

export function useMapViewport({ outline, bufferArea }: UseMapViewportParams) {
  const bufferAreaBounds = useMemo(() => {
    if (!bufferArea?.length) return null;

    return bbox(featureCollection(bufferArea));
  }, [bufferArea]);

  const centre = !outline?.length
    ? fallbackCoordinatesUK
    : centroid(outline[0]).geometry.coordinates;

  const initialViewState: InitialViewState = bufferAreaBounds
    ? {
        bounds: [
          [bufferAreaBounds[0], bufferAreaBounds[1]],
          [bufferAreaBounds[2], bufferAreaBounds[3]],
        ],
        fitBoundsOptions: {
          padding: 15,
        },
      }
    : {
        latitude: centre[1],
        longitude: centre[0],
        zoom: 10,
      };

  return {
    initialViewState,
  };
}
